var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCptrusted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.28125 1.39062C6.09375 1.29688 5.88281 1.29688 5.69531 1.39062L1.54688 3.14844C1.28906 3.24219 1.10156 3.5 1.125 3.78125C1.125 5.98438 2.03906 9.875 5.69531 11.6328C5.88281 11.7266 6.09375 11.7266 6.28125 11.6328C9.9375 9.875 10.8516 5.98438 10.875 3.78125C10.875 3.5 10.6875 3.24219 10.4297 3.14844L6.28125 1.39062ZM5.41406 0.6875C5.78906 0.523438 6.21094 0.523438 6.58594 0.6875L10.7109 2.44531C11.2266 2.67969 11.625 3.17188 11.625 3.78125C11.6016 6.125 10.6406 10.3672 6.60938 12.3125C6.21094 12.5 5.76562 12.5 5.36719 12.3125C1.33594 10.3672 0.375 6.125 0.375 3.78125C0.351562 3.17188 0.75 2.67969 1.26562 2.44531L5.41406 0.6875Z",
    fill: "#2AAD8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 826,
    height: 634,
    fill: "white",
    transform: "translate(0 -120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCptrusted);
export default __webpack_public_path__ + "static/media/cptrusted.c9e5ec0b01a723e866f00b285bd465d3.svg";
export { ForwardRef as ReactComponent };